import Checkbox, { ICheckboxProps as CheckboxProps } from './Checkbox';
import CheckboxInput, { ICheckboxInputProps as CheckboxInputProps } from './CheckboxInput';
import RangeCheckbox, { type IRangeCheckboxProps as RangeCheckboxProps } from './RangeCheckbox';
import checkboxStyles from './checkbox.module.scss';

export type { CheckboxProps, CheckboxInputProps, RangeCheckboxProps };
export { Checkbox, CheckboxInput, RangeCheckbox, checkboxStyles };
export default Checkbox;
